/*
  USER
 */
export const loginEndPoint = () => {
    return `/biframework/user/login`;
};

export const changeUserEndPoint = () => {
    return `/biframework/user/changeaccount`;
};

/*
  PACKAGE
 */
export const searchPackageEndPoint = (packageId, searchPhrase) => {
    return `/ess/searchpackage/${packageId}/${searchPhrase}`;
};

export const getDefaultEndPoint = () => {
    return "/package/getdefault";
};

/*
    ESS
 */
export const getEssEndPoint = essId => {
    return `/ess/id/${essId}`;
};

/*
    VP
 */
export const getCategoriesEndPoint = () => {
    return `/vp/categories`;
};

export const getVPTypesEndPoint = () => {
    return `/vp/types`;
};

export const getVPTypesByIdEndPoint = vpTypesId => {
    return `/vp/vpypes/${vpTypesId}`;
};

export const getVpByPackageAndTypeEndPoint = (packageId, vpTypeId) => {
    return `/vp/vpheaderbytype/${packageId}/${vpTypeId}`;
};

export const getWordDefinitionEndPoint = languageId => `/worddefinition/list/${languageId}`;



// WEBPACK FOOTER //
// ./retts/util/apiEndpoints.js